import { render, staticRenderFns } from "./VoiceControl.vue?vue&type=template&id=2ee5b528&scoped=true&"
import script from "./VoiceControl.js?vue&type=script&lang=js&"
export * from "./VoiceControl.js?vue&type=script&lang=js&"
import style0 from "./VoiceControl.scss?vue&type=style&index=0&id=2ee5b528&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee5b528",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
